var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "linkedin-channels" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: _vm.$t("Linkedin Channels") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex right-page",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "ml-3 mt-3", staticStyle: { flex: "0 0 100%" } },
            [
              _c("div", { staticClass: "big-title" }, [
                _vm._v(_vm._s(_vm.$t("message.linkedinChannels"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "channels" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "story channel-add",
                      on: {
                        click: function ($event) {
                          return _vm.$feature.beforeCreateIntegrationChannel(
                            _vm.createChannel,
                            "linkedin-unipile"
                          )
                        },
                      },
                    },
                    [
                      _c("a-icon", {
                        staticStyle: { "font-size": "30px" },
                        attrs: { type: "plus-circle", theme: "filled" },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "text-large font-weight-bolder mt-2",
                          staticStyle: {
                            "font-size": "20px",
                            "letter-spacing": "2px",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("whatsappChannel.addChannel")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.channels, function (channel, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "channel-item",
                        class: { disabled: !_vm.isChannelAccessible(channel) },
                        on: {
                          click: function () {
                            return (
                              _vm.isChannelAccessible(channel) &&
                              _vm.editChannel(channel)
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "icon-container" },
                          [_c("LinkedinIcon")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "name-container" }, [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(channel.name.toUpperCase())),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "phone" }, [
                            _vm._v(" ---- "),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "options" },
                          [
                            _c("UnipileChannelStatusBadge", {
                              attrs: { channel: channel },
                            }),
                            _vm._v(" "),
                            _c(
                              "a-dropdown",
                              {
                                attrs: {
                                  trigger: ["click"],
                                  placement: "bottomRight",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "overlay",
                                      fn: function () {
                                        return [
                                          _c(
                                            "a-menu",
                                            [
                                              _c("a-menu-item", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "icon-container",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$router.push(
                                                          "/integrations/linkedin/" +
                                                            channel._id +
                                                            "/detail"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "md-icon",
                                                      {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "10px",
                                                        },
                                                      },
                                                      [_vm._v("edit")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("message.edit")
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "a-menu-item",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    gap: "5px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyChannelId(
                                                        channel._id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("content_copy")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "Channel ID Kopyala"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("a-menu-item", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "icon-container",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteWpBusiness(
                                                          channel._id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "md-icon",
                                                      {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "10px",
                                                        },
                                                      },
                                                      [_vm._v("delete")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.delete"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "icon-container ant-dropdown-link",
                                    on: {
                                      click: function (e) {
                                        return e.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("more_horiz")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showCreateForm
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("Add Linkedin Channel"),
                description: _vm.$t("Connect your Linkedin account"),
                "class-name": "new-waba",
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showCreateForm = false
                },
              },
            },
            [
              _c("NewLinkedinChannel", {
                on: {
                  cancel: function ($event) {
                    _vm.showCreateForm = false
                  },
                  ok: function ($event) {
                    _vm.showCreateForm = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.updatingChannel
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("Update Linkedin Channel"),
                description: _vm.$t("message.updateLinkedinChannelDesc"),
                "class-name": "new-waba",
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.updatingChannel = null
                },
              },
            },
            [
              _c("UpdateLinkedinChannel", {
                attrs: { channel: _vm.updatingChannel },
                on: {
                  cancel: function ($event) {
                    _vm.updatingChannel = false
                  },
                  ok: function ($event) {
                    _vm.updatingChannel = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.deleteModal,
            icon: "exclamation-circle",
            title: _vm.$t("message.deleteLinkedinChannel"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteWhatsappChannel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.confirmDeleteLinkedinChannel"))),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }